module.exports = __webpack_public_path__ + "static/media/dtmIcon.6483fd1b.svg";